import { app } from '../../../bootstrap/core';
import sellFragmentsComponent from './sellFragments.component';

app.component('sellFragments', sellFragmentsComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/sellFragments/sellFragments.js